<template>
  <div class="flex justify-end">
    <button
      type="button"
      class="text-text-positive-primary text-sm"
      @click="emit('resetPassengerData')"
    >
      {{ t('passengerDataForm.resetFields') }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const emit = defineEmits<{
    resetPassengerData: [];
  }>();

  const { t } = useI18n();
</script>
<i18n src="../config/locales.json"></i18n>
